import { ReactNode } from 'react';
import ConditionalRenderer from '../ui/custom/ConditionalRenderer';

export type WorkspaceHeaderProps = {
  title: ReactNode;
  subtitle: string;
  description?: string;
};

export default function WorkspaceHeader({
  title,
  subtitle,
  description,
}: WorkspaceHeaderProps) {
  return (
    <div className="flex flex-col gap-2">
      <h4 className="text-sm! mb-0 mt-0! text-primary font-semibold leading-5">
        {title}
      </h4>
      <h2 className="text-2xl font-medium text-base-content leading-8">
        {subtitle}
      </h2>
      <ConditionalRenderer condition={!!description}>
        <p className="text-base text-base-content leading-7">{description}</p>
      </ConditionalRenderer>
    </div>
  );
}
